<template>
  <div class="dashboard-employee-section">
    <div class="dashboard-employee-container">
      <!-- Mobile tabs container -->
      <div class="dashboard-employee-tabs">
        <div class="employee-tabs-container">
          <div class="employee-tabs-content">
            <div
              v-for="data in tabsList"
              :key="data"
              @click="openTab(data.id)"
              class="employee-tab-content"
              :class="{'tab-content-active' : (tabActive == data.id)}"
            >
              {{ data.label }}
            </div>
          </div>
        </div>
      </div>

      <div class="dashboard-employee-content">
        <div class="dashboard-employee-outer">
          <div
            v-if="profileData.id"
            class="employee-outer-content"
            :style="(tabActive != 0) ? 'margin-left: calc((-100vw) *' + tabActive + ');' : 'margin-left: 0;'"
          >
            <!-- Container for mobile responsive -->
            <IndexInfo
              :tab-active="(tabActive == 0) ? true : false"
              :load-data="isLoading"
              :this-monthnow="thisMonthNow"
              :attendance-day="attendanceDay"
              :attendance-now="attendanceNow"
              :attendance-data="attendanceData"
              :attendance-aLL="attendanceALL"
              :leave-balance="leaveBalance"
              :latest-update="latestUpdate"
              :latest-updatefull="latestUpdateFull"
              :profile-data="profileData"
              :punishment-payroll="punishmentPayroll"
              :punishment-perfomance="punishmentPerfomance"
              :punishment-position="punishmentPosition"
              :punishment-terminated="punishmentTerminated"
              :punishment-payrollfull="punishmentPayrollFull"
              :punishment-perfomancefull="punishmentPerfomanceFull"
              :punishment-positionfull="punishmentPositionFull"
              :punishment-terminatedfull="punishmentTerminatedFull"
              @open-modal="openModal($event)"
              @open-detail="openDetail($event)"
              class="tab-mobile"
            />

            <IndexPermission
              :tab-active="(tabActive == 1) ? true : false"
              :load-data="isLoading"
              :this-monthnow="thisMonthNow"
              :leave-waiting="leaveWaiting"
              :leave-waitingfull="leaveWaitingFull"
              :leave-approve="leaveApprove"
              :leave-approvefull="leaveApproveFull"
              :leave-reject="leaveReject"
              :leave-rejectfull="leaveRejectFull"
              :training-waiting="trainingWaiting"
              :training-approve="trainingApprove"
              :training-reject="trainingReject"
              :training-waitingfull="trainingWaitingFull"
              :training-approvefull="trainingApproveFull"
              :training-rejectfull="trainingRejectFull"
              @open-modal="openModal($event)"
              @open-detail="openDetail($event)"
              class="tab-mobile"
            />

            <IndexExpiring
              :tab-active="(tabActive == 2) ? true : false"
              :load-data="isLoading"
              :this-monthnow="thisMonthNow"
              :expiring-contract="expiringContract"
              :expiring-contractfull="expiringContractFull"
              :expiring-career="expiringCareer"
              :expiring-careerfull="expiringCareerFull"
              :expiring-doc="expiringDoc"
              :expiring-docfull="expiringDocFull"
              :expired-contract="expiredContract"
              :expired-contractfull="expiredContractFull"
              :expired-career="expiredCareer"
              :expired-careerfull="expiredCareerFull"
              :expired-doc="expiredDoc"
              :expired-docfull="expiredDocFull"
              @open-modal="openModal($event)"
              @open-detail="openDetail($event)"
              class="tab-mobile"
            />

            <!-- Container for website responsive -->
            <IndexPermission
              :load-data="isLoading"
              :this-monthnow="thisMonthNow"
              :leave-waiting="leaveWaiting"
              :leave-waitingfull="leaveWaitingFull"
              :leave-approve="leaveApprove"
              :leave-approvefull="leaveApproveFull"
              :leave-reject="leaveReject"
              :leave-rejectfull="leaveRejectFull"
              :training-waiting="trainingWaiting"
              :training-approve="trainingApprove"
              :training-reject="trainingReject"
              :training-waitingfull="trainingWaitingFull"
              :training-approvefull="trainingApproveFull"
              :training-rejectfull="trainingRejectFull"
              @open-modal="openModal($event)"
              @open-detail="openDetail($event)"
              class="tab-desktop"
            />

            <IndexInfo
              :load-data="isLoading"
              :this-monthnow="thisMonthNow"
              :attendance-day="attendanceDay"
              :attendance-now="attendanceNow"
              :attendance-data="attendanceData"
              :attendance-aLL="attendanceALL"
              :leave-balance="leaveBalance"
              :latest-update="latestUpdate"
              :latest-updatefull="latestUpdateFull"
              :profile-data="profileData"
              :punishment-payroll="punishmentPayroll"
              :punishment-perfomance="punishmentPerfomance"
              :punishment-position="punishmentPosition"
              :punishment-terminated="punishmentTerminated"
              :punishment-payrollfull="punishmentPayrollFull"
              :punishment-perfomancefull="punishmentPerfomanceFull"
              :punishment-positionfull="punishmentPositionFull"
              :punishment-terminatedfull="punishmentTerminatedFull"
              @open-modal="openModal($event)"
              @open-detail="openDetail($event)"
              class="tab-desktop"
            />

            <IndexExpiring
              :load-data="isLoading"
              :this-monthnow="thisMonthNow"
              :expiring-contract="expiringContract"
              :expiring-contractfull="expiringContractFull"
              :expiring-decree="expiringCareer"
              :expiring-decreefull="expiringCareerFull"
              :expiring-doc="expiringDoc"
              :expiring-docfull="expiringDocFull"
              :expired-contract="expiredContract"
              :expired-contractfull="expiredContractFull"
              :expired-decree="expiredCareer"
              :expired-decreefull="expiredCareerFull"
              :expired-doc="expiredDoc"
              :expired-docfull="expiredDocFull"
              @open-modal="openModal($event)"
              @open-detail="openDetail($event)"
              class="tab-desktop"
            />
          </div>

          <div v-else class="employee-outer-content-blank">
            <div class="inner-blank">
              <p>No personal information</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Detail modal -> list -->
  <vue-final-modal
    v-for="(index, value) in modalDetail" :key="value"
    v-model="modalDetail[value]"
    classes="base-modal"
    :ssr="true"
    content-class="base-modal-dashboard-employee bg-gray-100 dark:bg-gray-700 transition-colors duration-1000"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false" transition="vfm" overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false" drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1>
        {{
          (value == 'attendance') ? 'Attendance Record' :
          (value == 'leaveBalance') ? 'Leave Balance' :
          (value == 'latestUpdate') ? 'Update Details' :
          (value == 'leaveWaiting') ? 'Leave Details' :
          (value == 'leaveApprove') ? 'Leave Details' :
          (value == 'leaveReject') ? 'Leave Details' :
          (value == 'trainingWaiting') ? 'Training Details' :
          (value == 'trainingApprove') ? 'Training Details' :
          (value == 'trainingReject') ? 'Training Details' :
          (value == 'expiringDoc') ? 'Expiring Document Details' :
          (value == 'expiredDoc') ? 'Expired Document Details' :
          (value == 'expiringDecree') ? 'Expiring Decree Details' :
          (value == 'expiredDecree') ? 'Expired Decree Details' :
          (value == 'expiringContract') ? 'Expiring Contract Details' :
          (value == 'expiredContract') ? 'Expired Contract Details' :
          (value == 'punishmentPayroll') ? 'Consider in Payroll Details' :
          (value == 'punishmentPerfomance') ? 'Consider in Perfomance Details' :
          (value == 'punishmentPosition') ? 'Relate to Position Details' :
          (value == 'punishmentTerminated') ? 'Is Terminated Details' : ''
        }}
      </h1>
      <jb-button class="btn-close-modal" :icon="mdiClose" @click="openModal({type: value, status: false})"/>
    </div>

    <!-- Modal Content -->
    <div class="modal-content-dashboard-employee">
      <div v-if="(value == 'attendance')" class="detail-attendance-content">
        <div v-if="objectDetail" class="attendance-content">
          <div v-for="data in objectDetail" :key="data" class="month-container">
            <div class="month-header">
              <p>{{ data.month_name + ' ' + data.year }}</p>
            </div>

            <div v-if="data.month_presence" class="month-outer">
              <div v-for="(child, index) in data.month_presence" :key="child" v-show="!['total_libur', 'total_present', 'total_tardy'].includes(index)" class="month-list">
                <div class="month-inner" :class="{'month-inner-full-red' : child[1] == 'Libur'}">
                  <div class="month-number">
                    <p v-if="child[1]" :class="{'text-red' : child[1].slice(8, child[1].length) == 'late'}">{{ index }}</p>
                    <p v-else>{{ index }}</p>
                  </div>

                  <div class="month-time">
                    <p v-if="(child[1] != 'Libur') && (child[1] || child[2])" :class="{'text-red' : child[1].slice(8, child[1].length) == 'late'}">{{ child[1].slice(0, 5) + ' - ' + child[2].slice(0, 5) + ' (' + child[1].slice(8, child[1].length) + ')' }}</p>
                    <p v-else>{{ child[1] }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div v-else-if="(value == 'leaveBalance')" class="detail-remaining-content"> -->
      <div v-else class="detail-remaining-content">
        <div v-if="objectDetail" class="detail-tree">
          <div v-if="objectDetail.length == 0" class="detail-tree-no">
            <p>No data!</p>
          </div>

          <div v-else v-for="parent in objectDetail" :key="parent" class="detail-tree-period">
            <div class="period-header">
              {{ parent.period ? parent.period : parent.year ? parent.year : '' }}
            </div>

            <div class="detail-tree-inherit">
              <div v-for="data in parent.list ? parent.list : parent.month ? parent.month : 0" :key="data" class="parent-tree-container">
                <div class="parent-tree-content">
                  <p v-if="data.sisa_cuti"><b>{{ data.leave_name }}</b> | Remaining leave balance: <b>{{ data.sisa_cuti }}</b></p>
                  <p v-else><b>{{ data.month_name }}</b></p>
                </div>

                <div
                  v-for="child in data.history_cuti ? data.history_cuti : data.data ? data.data : 0"
                  :key="child"
                  @click="
                    ['leaveWaiting', 'leaveApprove', 'leaveReject'].includes(value) ? openDetail(child, 'leave')
                    : ['trainingWaiting', 'trainingApprove', 'trainingReject'].includes(value) ? openDetail(child, 'training')
                    : ['expiringDecree', 'expiredDecree'].includes(value) ? openDetail(child, 'decree')
                    : ['expiringDoc', 'expiredDoc'].includes(value) ? openDetail(child, 'document')
                    : ['expiringContract', 'expiredContract'].includes(value) ? openDetail(child, 'contract')
                    : ['punishmentPayroll', 'punishmentPerfomance', 'punishmentPosition', 'punishmentTerminated'].includes(value) ? openDetail(child, 'punishment')
                    : null"
                  class="child-tree-container"
                  :class="{
                    'child-tree-yellow': ((child.state == 'Waiting for Approval') || (child.forState == 'Expiring') || (child.forState == 'yellow') || (child.forState == 'Expiring')),
                    'child-tree-green': ((child.state == 'Approved')) || (child.forState == 'green') || ((child.sign_type == '1') && data.history_cuti),
                    'child-tree-red': ((child.state == 'Rejected')) || (child.forState == 'red') || (child.forState == 'Expired') || ((child.sign_type == '-1') && data.history_cuti)
                  }"
                >
                  <p v-if="child.forValue1" class="list-name"><b v-html="child.forValue1" /></p>
                  <p v-else-if="data.history_cuti" class="list-name"><b v-html="formatDate('date', child.leave_date)" /></p>
                  <p v-else-if="!data.history_cuti" class="list-name"><b v-html="child.organizer ? (child.organizer + ' (' + child.venue + ')') : child.transaction_no ? child.transaction_no : child.title ? child.title : ''" /></p>

                  <p v-if="child.forValue4" class="list-subject" v-html="child.forValue4" />

                  <p v-if="child.forValue2" class="list-info" v-html="child.forValue2" />
                  <p v-else-if="data.history_cuti" class="list-info" v-html="child.transaction" />
                  <p v-else-if="!data.history_cuti" class="list-info" v-html="child.info ? child.info : child.name ? child.name : ''" />

                  <p v-if="child.forValue3" class="list-date" v-html="child.forValue3" />
                  <p v-else-if="!data.history_cuti" class="list-date" v-html="child.start_date ? formatDate('event', child.start_date, child.end_date) : child.created_at ? formatDate('date', child.created_at) : child.createdat ? formatDate('date', child.createdat) : ''" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </vue-final-modal>

  <!-- Detail modal -> transaction -->
  <vue-final-modal
    v-model="detailModal"
    classes="base-modal"
    :ssr="true"
    :content-class="{
      'relative h-5/6 flex flex-col mx-4 md:mx-0 pb-4 w-11/12 md:w-10/12 lg:w-10/12' : ['decree', 'document', 'contract'].includes(modalType),
      'relative h-5/6 flex flex-col mx-4 md:mx-0 pb-4 w-11/12 md:w-2/3 lg:w-1/2' : ['training', 'leave', 'punishment'].includes(modalType)
    }"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false" transition="vfm" overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false" drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <div class="modal-head">
      <h1 v-if="modalType == 'training'">{{ $t("employeetraining.detail") }}</h1>
      <h1 v-else-if="modalType == 'leave'">Detail Transaction</h1>
      <h1 v-else-if="modalType == 'decree'">Detail Decree</h1>
      <h1 v-else-if="modalType == 'document'">Detail Document</h1>
      <h1 v-else-if="modalType == 'contract'">Detail Contract</h1>
      <h1 v-else-if="modalType == 'punishment'">Detail Punishment</h1>
      <jb-button class="btn-close-modal" :icon="mdiClose" @click="openDetail()" />
    </div>

    <div class="modal-content detail-content" style="background-color: white;">
      <EmployeeTrainingDetail v-if="modalType == 'training'" :prop-employee-training="detailData" @close-modal="openDetail()" @refresh-list="refreshData()" />

      <HrreqleaveDetail v-else-if="modalType == 'leave'" :prop-class="detailData" @close-modal="openDetail()" @refresh-list="refreshData()" />

      <EmployeeDetail v-else-if="['decree', 'document', 'contract'].includes(modalType)" :prop-class="detailData" :prop-id="detailData.employee_id" :is-decree="(modalType == 'decree') ? true : false" :is-contract="(modalType == 'contract') ? true : false" :is-document="(modalType == 'document') ? true : false" @close-modal="openDetail()" />

      <PunishmentTransactionDetail v-else-if="modalType == 'punishment'" :prop-class="detailData" @close-modal="openDetail()"/>
    </div>
  </vue-final-modal>
</template>

<script>
  /* eslint-disable */
  import { defineComponent, ref, reactive, onBeforeMount, onMounted, watch, watchEffect, computed } from "vue"
  import { useRouter, useRoute } from "vue-router"
  import { useI18n } from 'vue-i18n'
  import { useStore } from 'vuex'
  import axios from 'axios'
  import dayjs from 'dayjs'
  import { mdiClose } from '@mdi/js'

  import JbButton from '@/components/JbButton'
  import IndexInfo from "@/views/referensi/employee/EmployeeInfo/IndexInfo.vue"
  import IndexPermission from "@/views/referensi/employee/EmployeeInfo/IndexPermission.vue"
  import IndexExpiring from "@/views/referensi/employee/EmployeeInfo/IndexExpiring.vue"
  import HrreqleaveDetail from '@/views/humanresource/hrreqleave/Detail'
  import EmployeeTrainingDetail from "@/views/humanresource/employeetraining/EmployeeTrainingDetail"
  import EmployeeDetail from '@/views/referensi/employee/EmployeeDetail'
  import PunishmentTransactionDetail from "@/views/humanresource/punishmentTransaction/PunishmentTransactionDetail"

  export default {
    components: {
      JbButton,
      IndexInfo,
      IndexPermission,
      IndexExpiring,
      HrreqleaveDetail,
      EmployeeTrainingDetail,
      EmployeeDetail,
      PunishmentTransactionDetail
    },

    setup(props, { emit }) {
      const { t, locale } = useI18n()
      const router = useRouter()
      const route = useRoute()
      const store = useStore()
      const isLoading = ref(false)
      const employeeId = computed(() => localStorage.getItem('employee_id'))
      const userId = computed(() => localStorage.getItem('user_id'))
      const branchId = computed(() => localStorage.getItem('branch_id'))
      const usernameLogin = computed(() => localStorage.getItem('username'))
      const roles = computed(() => localStorage.getItem('roles'))


      const tabsList = ref([
        {
          id: 0,
          label: "Information"
        },
        {
          id: 1,
          label: "Document State"
        },
        {
          id: 2,
          label: "Expired Documents"
        }
      ])
      const tabActive = ref(0)
      const openTab = (id) => {
        tabActive.value = id
      }


      const monthsId = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"]
      const monthsEn = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      const shortMonthsId = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"]
      const shortMonthsEn = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Agu", "Sep", "Oct", "Nov", "Dec"]
      const daysId = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
      const daysEn = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]

      function formatDate(type, date, dateSec) {
        const start = new Date(date)
        const end = new Date(dateSec)

        const day = start.getDate()
        const month = start.getMonth()
        const year = start.getFullYear()
        const dayOfWeek = start.getDay()

        const months = locale.value == 'id' ? monthsId : monthsEn
        const monthsShort = locale.value == 'id' ? shortMonthsId : shortMonthsEn
        const days = locale.value == 'id' ? daysId : daysEn
        // const daysShort = locale.value == 'id' ? shortDaysId : shortDaysEn

        if(type == 'dateTime') {
          return `${daysEn[dayOfWeek]}, ${day} ${monthsEn[month]} ${year}`
        }
        else if(type == 'monthYear') {
          return `${monthsEn[month]} ${year}`
        }
        else if(type == 'month') {
          return `${monthsEn[month]}`
        }
        else if(type == 'monthNum') {
          return `${month}`
        }
        else if(type == 'date') {
          return `${day} ${monthsEn[month]} ${year}`
        }
        else if(type == 'day') {
          return `${day}`
        }
        else if (type == 'event') {
          const endDay = end.getDate()
          const endMonth = end.getMonth()
          const endYear = end.getFullYear()

          const startTime = start.toLocaleTimeString('id-ID', {
            hour: '2-digit', minute: '2-digit', hour12: false
          }).replace(":", ".")

          const endTime = end.toLocaleTimeString('id-ID', {
            hour: '2-digit', minute: '2-digit', hour12: false
          }).replace(":", ".")

          const isZeroTime = startTime === "00.00" && endTime === "00.00"
          const timeRange = isZeroTime ? "" : ` (${startTime} - ${endTime})`

          if (day === endDay && month === endMonth && year === endYear) {
            return `${days[dayOfWeek]}, ${day} ${monthsShort[month]} ${year}${timeRange}`
          } else if (month === endMonth && year === endYear) {
            return `${day} - ${endDay} ${monthsShort[month]} ${year}${timeRange}`
          } else {
            return `${day} ${monthsShort[month]} - ${endDay} ${monthsShort[endMonth]} ${endYear}${timeRange}`
          }
        }
      }


      const modalDetail = reactive({
        attendance: false,
        leaveBalance: false,
        latestUpdate: false,
        leaveWaiting: false,
        leaveApprove: false,
        leaveReject: false,
        trainingWaiting: false,
        trainingApprove: false,
        trainingReject: false,
        expiringDoc: false,
        expiredDoc: false,
        expiringDecree: false,
        expiredDecree: false,
        expiringContract: false,
        expiredContract: false,
        punishmentPayroll: false,
        punishmentPerfomance: false,
        punishmentPosition: false,
        punishmentTerminated: false
      })
      const objectDetail = ref({})
      const openModal = (event) => {
        // console.log("cek modal", event)

        modalDetail[event.type] = event.status ? event.status : false
        objectDetail.value = (event.data ? event.data : {})

        // console.log("cek ges", objectDetail.value)
      }


      const profileData = ref({
        id: null
      })
      const attendanceDay = ref("")
      const thisMonthNow = ref("")
      const attendanceNow = ref({})
      const attendanceData = ref({})
      const attendanceALL = ref([])
      const leaveBalance = ref({})
      const latestUpdate = ref({})
      const latestUpdateFull = ref({})

      const leaveWaiting = ref([])
      const leaveApprove = ref([])
      const leaveReject = ref([])
      const leaveWaitingFull = ref([])
      const leaveApproveFull = ref([])
      const leaveRejectFull = ref([])

      const trainingWaiting = ref([])
      const trainingApprove = ref([])
      const trainingReject = ref([])
      const trainingWaitingFull = ref([])
      const trainingApproveFull = ref([])
      const trainingRejectFull = ref([])

      const expiringDoc = ref([])
      const expiredDoc = ref([])
      const expiringDocFull = ref([])
      const expiredDocFull = ref([])

      const expiringLeave = ref([])
      const expiredLeave = ref([])
      const expiringLeaveFull = ref([])
      const expiredLeaveFull = ref([])

      const expiringContract = ref([])
      const expiredContract = ref([])
      const expiringContractFull = ref([])
      const expiredContractFull = ref([])

      const expiringCareer = ref([])
      const expiredCareer = ref([])
      const expiringCareerFull = ref([])
      const expiredCareerFull = ref([])

      const punishmentPayroll = ref([])
      const punishmentPayrollFull = ref([])
      const punishmentPerfomance = ref([])
      const punishmentPerfomanceFull = ref([])
      const punishmentPosition = ref([])
      const punishmentPositionFull = ref([])
      const punishmentTerminated = ref([])
      const punishmentTerminatedFull = ref([])

      const getData = async () => {
        isLoading.value = true

        const thisDate = new Date()
        let thisYear = thisDate.getFullYear()
        let thisMonth = ('0' + (thisDate.getMonth() + 1)).slice(-2)
        const monthNow = (thisYear + '-' + thisMonth)

        const headers = {'Content-Encoding': 'gzip'}
        const paramsEmployee = {user_id: userId.value, branch_id: branchId.value}
        const paramsProfile = {employee_id: employeeId.value}
        const leaveHistory = {user_id: userId.value, employee_id: (employeeId.value != 'null') ? employeeId.value : null }
        const leaveWait = {username: usernameLogin.value}
        const leavePermission = {username: usernameLogin.value, is_all: true}

        const testParams1 = {
          user_id: userId.value,
          is_personal: 0,
          year: thisYear,
          month: thisMonth
        }

        const paramsLeave = {
          username: usernameLogin.value,
          is_all: true,
          is_personal: 1,
          year: thisYear,
          month: thisMonth
        }

        const paramsLeaveFull = {
          username: usernameLogin.value,
          is_all: true,
          is_personal: 1,
          year: null,
          month: null
        }

        const paramsExpire = {
          user_id: userId.value,
          is_personal: 1,
          year: thisYear,
          month: thisMonth
        }

        const paramsExpireFull = {
          user_id: userId.value,
          is_personal: 1,
          year: null,
          month: null
        }

        const paramsPunishment = {
          user_id: userId.value,
          branch_id: branchId.value,
          is_personal: 1,
          year: thisYear,
          month: thisMonth
        }

        const paramsPunishmentFull = {
          user_id: userId.value,
          branch_id: branchId.value,
          is_personal: 1,
          year: null,
          month: null
        }

        try {
          const [response1, response2, response3, response4, response5, response6, response7, response8, response9] = await Promise.all([
            // axios.get("get-leave-history", { headers, params: leaveHistory }),
            axios.get("get-leave-history", { headers, params: testParams1 }),
            axios.get("get-last-update-employee", { headers, params: leaveHistory }),
            axios.get("employee", { headers, params: paramsEmployee }),
            axios.get("get-leave-notif", { headers, params: paramsLeave }),
            axios.get("get-leave-notif", { headers, params: paramsLeaveFull }),
            axios.get("get-list-expired-employee", { headers, params: paramsExpire }),
            axios.get("get-list-expired-employee", { headers, params: paramsExpireFull }),
            axios.get("dashboard-punishment", { headers, params: paramsPunishment }),
            axios.get("dashboard-punishment", { headers, params: paramsPunishmentFull })
          ])

          if(response1.data.data) {
            const backData = response1.data.data
            const prevData = []

            // console.log("cek back data", backData)

            for (const [index, value] of Object.entries(response1.data.data)) {
              const grouped = backData.reduce((acc, item) => {
                if (!acc[item.period]) {
                  acc[item.period] = []
                }
                acc[item.period].push(item)
                return acc
              }, {})

              const result = Object.keys(grouped)
                .sort((a, b) => b - a)
                .map(period => ({period, list: grouped[period].filter(item => item.id == value.id)[0].list_leave}))
              value['list_period'] = result

              prevData.push(value)
            }


            // console.log("cek back data", backData)
            // console.log("cek filter employee", backData.filter(item => item.id == employeeId.value)[0])

            leaveBalance.value = backData.filter(item => item.id == employeeId.value)[0]
            // console.log("cek leave balance", leaveBalance.value)
          }

          if(response2.data.data) {
            const prevData = response2.data.data
            latestUpdate.value = prevData.filter(item => item.createdat.startsWith(monthNow))
            latestUpdateFull.value = prevData
            // console.log("cek latest update", latestUpdate.value)
          }

          if(response3.data.data) {
            const baseData = response3.data.data
            // console.log("cek pre profile", response3.data, baseData)

            if(baseData) {
              if(baseData.filter(item => item.employee_id == employeeId.value)) {
                const preData = baseData.filter(item => item.employee_id == employeeId.value)[0]

                if(preData) {
                  preData['img_profile'] = null
                  profileData.value = preData
                  getDataSec(preData)
                }
              }
              else {
                profileData.value = {}
              }
            }

            // console.log("cek employee profile", employeeId.value, profileData.value)
          }

          if(response4.data.data) {
            const prevData = response4.data.data.filter(item => item.employee_id == employeeId.value)

            // console.log("cek permission leave", prevData)

            if(prevData) {
              const formatData = []

              for (const [index, value] of Object.entries(prevData)) {
                const formatLoop = {
                  id: value.id,
                  value1: value.transaction_no,
                  value2: value.info,
                  value3: formatDate('date', value.createdat),
                  value5: (value.state == 'Approved') ? ('Approved by<br>' + value.updated_by) : (value.state == 'Rejected') ? ('Rejected by<br>' + value.updated_by) : null,
                  state: value.state
                }

                formatData.push(formatLoop)
              }

              // console.log("cek permission loop", formatData)

              leaveWaiting.value = formatData.filter(item => item.state == "Waiting for Approval").slice(0, 10)
              leaveApprove.value = formatData.filter(item => item.state == "Approved").slice(0, 10)
              leaveReject.value = formatData.filter(item => item.state == "Rejected").slice(0, 10)

              // console.log("cek leave waiting", leaveWaiting.value)
              // console.log("cek leave approve", leaveApprove.value)
              // console.log("cek leave reject", leaveReject.value)
            }
          }

          if(response4.data.dataTraining) {
            const prevData = response4.data.dataTraining

            // console.log("cek training data", prevData)

            if(prevData) {
              const formatData = []

              for (const [index, value] of Object.entries(prevData)) {
                const formatLoop = {
                  id: value.id,
                  value1: value.organizer + ' (' + value.venue + ')',
                  value2: value.name,
                  value3: formatDate('event', value.start_date, value.end_date),
                  value5: (value.state == 'Approved') ? ('Approved by<br>' + value.updated_by) : (value.state == 'Rejected') ? ('Rejected by<br>' + value.updated_by) : null,
                  state: value.state,
                  forFormatDate: value.start_date
                }

                formatData.push(formatLoop)
              }

              // console.log("cek training loop", formatData)

              trainingWaiting.value = formatData.filter(item => item.state == "Waiting for Approval").slice(0, 10)
              trainingApprove.value = formatData.filter(item => item.state == "Approved").slice(0, 10)
              trainingReject.value = formatData.filter(item => item.state == "Rejected").slice(0, 10)

              // console.log("cek training waiting", trainingWaiting.value)
              // console.log("cek training approve", trainingApprove.value)
              // console.log("cek training reject", trainingReject.value)
            }
          }

          if(response5.data.data) {
            const prevData = response5.data.data.filter(item => item.employee_id == employeeId.value)

            // console.log("cek permission full", prevData)

            if(prevData) {
              const formatData = []

              for (const [index, value] of Object.entries(prevData)) {
                // console.log("cek permission loop", value)

                const formatLoop = value
                formatLoop['forFormatDate'] = value.createdat

                formatData.push(formatLoop)
              }

              // console.log("cek permission loop", formatData)

              leaveWaitingFull.value = formatData.filter(item => item.state == "Waiting for Approval")
              leaveApproveFull.value = formatData.filter(item => item.state == "Approved")
              leaveRejectFull.value = formatData.filter(item => item.state == "Rejected")

              // console.log("cek leave waiting full", leaveWaitingFull.value)
              // console.log("cek leave approve full", leaveApproveFull.value)
              // console.log("cek leave reject full", leaveRejectFull.value)
            }
          }

          if(response5.data.dataTraining) {
            const prevData = response5.data.dataTraining

            // console.log("cek training all data", prevData)

            if(prevData) {
              const formatData = []

              for (const [index, value] of Object.entries(prevData)) {
                const formatLoop = value
                formatLoop['forId'] = value.id
                formatLoop['forFormatDate'] = value.start_date
                // formatLoop['forValue1'] = value.employee_name + ' (' + value.venue + ')'
                formatLoop['forValue1'] = value.employee_name
                formatLoop['forValue2'] = value.name
                formatLoop['forValue3'] = formatDate('event', value.start_date, value.end_date)
                formatLoop['forValue4'] = value.organizer + ' (' + value.venue + ')',
                formatLoop['forState'] = value.state

                formatData.push(formatLoop)
              }

              // console.log("cek training loop", formatData)

              trainingWaitingFull.value = formatData.filter(item => item.state == "Waiting for Approval")
              trainingApproveFull.value = formatData.filter(item => item.state == "Approved")
              trainingRejectFull.value = formatData.filter(item => item.state == "Rejected")

              // console.log("cek training waiting full", trainingWaitingFull.value)
              // console.log("cek training approve full", trainingApproveFull.value)
              // console.log("cek training reject full", trainingRejectFull.value)
            }
          }

          // ----- Data is expiring & expired this month (contract, decree, document) -----
          if(response6.data) {
            const basicData = response6.data
            const prevExgContract = basicData.dataContractExpiring
            const prevExdContract = basicData.dataContractExpired
            const prevExgDecree = basicData.dataCareerPathExpiring
            const prevExdDecree = basicData.dataCareerPathExpired
            const prevExgDocument = basicData.dataTrainingDocExpiring
            const prevExdDocument = basicData.dataTrainingDocExpired

            // console.log("cek contract", prevExgContract, prevExdContract)

            // console.log("cek all", basicData)

            // console.log("cek contract expiring prev", prevExgContract)
            // Expiring contract
            if(prevExgContract) {
              const formatData = []

              for (const [index, value] of Object.entries(prevExgContract)) {
                const formatLoop = {
                  id: value.employee_id,
                  value1: value.employee_name,
                  value2: value.info,
                  value3: formatDate('date', value.transaction_no),
                  state: null
                }

                formatData.push(formatLoop)
              }

              expiringContract.value = formatData.slice(0, 10)
              // console.log("cek expiring contract", expiringContract.value)
            }

            // console.log("cek contract expired prev", prevExdContract)
            // Expired contract
            if(prevExdContract) {
              const formatData = []

              for (const [index, value] of Object.entries(prevExdContract)) {
                const formatLoop = {
                  id: value.employee_id,
                  value1: value.employee_name,
                  value2: value.info,
                  value3: formatDate('date', value.transaction_no),
                  state: null
                }

                formatData.push(formatLoop)
              }

              expiredContract.value = formatData.slice(0, 10)
              // console.log("cek expired contract", expiredContract.value)
            }

            // console.log("cek decree expiring prev", prevExgDecree)
            // Expiring decree
            if(prevExgDecree) {
              const formatData = []

              for (const [index, value] of Object.entries(prevExgDecree)) {
                const formatLoop = {
                  id: value.employee_id,
                  value1: value.employee_name,
                  value2: value.info,
                  value3: formatDate('date', value.transaction_no),
                  state: null
                }

                formatData.push(formatLoop)
              }

              expiringCareer.value = formatData.slice(0, 10)
              // console.log("cek expiring decree", expiringCareer.value)
            }

            // console.log("cek decree expired prev", prevExdDecree)
            // Expired decree
            if(prevExdDecree) {
              const formatData = []

              for (const [index, value] of Object.entries(prevExdDecree)) {
                const formatLoop = {
                  id: value.employee_id,
                  value1: value.employee_name,
                  value2: value.info,
                  value3: formatDate('date', value.transaction_no),
                  state: null
                }

                formatData.push(formatLoop)
              }

              expiredCareer.value = formatData.slice(0, 10)
              // console.log("cek expired decree", expiredCareer.value)
            }

            // console.log("cek document expiring prev", prevExgDocument)
            // Expiring document
            if(prevExgDocument) {
              const formatData = []

              for (const [index, value] of Object.entries(prevExgDocument)) {
                const formatLoop = {
                  id: value.employee_id,
                  value1: value.employee_name,
                  value2: value.info,
                  value3: formatDate('date', value.transaction_no),
                  state: null
                }

                formatData.push(formatLoop)
              }

              expiringDoc.value = formatData.slice(0, 10)
              // console.log("cek expiring document", expiringDoc.value)
            }

            // console.log("cek document expired prev", prevExdDocument)
            // Expired document
            if(prevExdDocument) {
              const formatData = []

              for (const [index, value] of Object.entries(prevExdDocument)) {
                const formatLoop = {
                  id: value.employee_id,
                  value1: value.employee_name,
                  value2: value.info,
                  value3: formatDate('date', value.transaction_no),
                  state: null
                }

                formatData.push(formatLoop)
              }

              expiredDoc.value = formatData.slice(0, 10)
              // console.log("cek expired document", expiredDoc.value)
            }
          }

          // ----- Data is expiring & expired all month & year (contract, decree, document) -----
          if(response7.data) {
            const basicData = response7.data
            const prevExgContract = basicData.dataContractExpiring
            const prevExdContract = basicData.dataContractExpired
            const prevExgDecree = basicData.dataCareerPathExpiring
            const prevExdDecree = basicData.dataCareerPathExpired
            const prevExgDocument = basicData.dataTrainingDocExpiring
            const prevExdDocument = basicData.dataTrainingDocExpired

            // console.log("cek all", basicData)

            // console.log("cek contract expiring prev", prevExgContract)
            // Expiring contract
            if(prevExgContract) {
              const formatData = []

              for (const [index, value] of Object.entries(prevExgContract)) {
                // const formatLoop = {
                //   id: null,
                //   value1: value.employee_name,
                //   value2: value.info,
                //   value3: formatDate('date', value.transaction_no),
                //   state: null
                // }

                const formatLoop = value
                formatLoop['forId'] = null
                formatLoop['forFormatDate'] = value.transaction_no
                formatLoop['forValue1'] = value.employee_name
                formatLoop['forValue2'] = value.info
                formatLoop['forValue3'] =  formatDate('date', value.transaction_no)
                formatLoop['forState'] = 'Expiring'

                formatData.push(formatLoop)
              }

              expiringContractFull.value = formatData
              // console.log("cek expiring contract", expiringContractFull.value)
            }

            // console.log("cek contract expired prev", prevExdContract)
            // Expired contract
            if(prevExdContract) {
              const formatData = []

              for (const [index, value] of Object.entries(prevExdContract)) {
                // const formatLoop = {
                //   id: null,
                //   value1: value.employee_name,
                //   value2: value.info,
                //   value3: formatDate('date', value.transaction_no),
                //   state: null
                // }

                const formatLoop = value
                formatLoop['forId'] = null
                formatLoop['forFormatDate'] = value.transaction_no
                formatLoop['forValue1'] = value.employee_name
                formatLoop['forValue2'] = value.info
                formatLoop['forValue3'] =  formatDate('date', value.transaction_no)
                formatLoop['forState'] = 'Expired'

                formatData.push(formatLoop)
              }

              expiredContractFull.value = formatData
              // console.log("cek expired contract", expiredContractFull.value)
            }

            // console.log("cek decree expiring prev", prevExgDecree)
            // Expiring decree
            if(prevExgDecree) {
              const formatData = []

              for (const [index, value] of Object.entries(prevExgDecree)) {
                // const formatLoop = {
                //   id: null,
                //   value1: value.employee_name,
                //   value2: value.info,
                //   value3: formatDate('date', value.transaction_no),
                //   state: null
                // }

                const formatLoop = value
                formatLoop['forId'] = null
                formatLoop['forFormatDate'] = value.transaction_no
                formatLoop['forValue1'] = value.employee_name
                formatLoop['forValue2'] = value.info
                formatLoop['forValue3'] =  formatDate('date', value.transaction_no)
                formatLoop['forState'] = 'Expiring'

                formatData.push(formatLoop)
              }

              expiringCareerFull.value = formatData
              // console.log("cek expiring decree", expiringCareerFull.value)
            }

            // console.log("cek decree expired prev", prevExdDecree)
            // Expired decree
            if(prevExdDecree) {
              const formatData = []

              for (const [index, value] of Object.entries(prevExdDecree)) {
                // const formatLoop = {
                //   id: null,
                //   value1: value.employee_name,
                //   value2: value.info,
                //   value3: formatDate('date', value.transaction_no),
                //   state: null
                // }

                const formatLoop = value
                formatLoop['forId'] = null
                formatLoop['forFormatDate'] = value.transaction_no
                formatLoop['forValue1'] = value.employee_name
                formatLoop['forValue2'] = value.info
                formatLoop['forValue3'] =  formatDate('date', value.transaction_no)
                formatLoop['forState'] = 'Expired'

                formatData.push(formatLoop)
              }

              expiredCareerFull.value = formatData
              // console.log("cek expired decree", expiredCareerFull.value)
            }

            // console.log("cek document expiring prev", prevExgDocument)
            // Expiring document
            if(prevExgDocument) {
              const formatData = []

              for (const [index, value] of Object.entries(prevExgDocument)) {
                // const formatLoop = {
                //   id: null,
                //   value1: value.employee_name,
                //   value2: value.info,
                //   value3: formatDate('date', value.transaction_no),
                //   state: null
                // }

                const formatLoop = value
                formatLoop['forId'] = null
                formatLoop['forFormatDate'] = value.transaction_no
                formatLoop['forValue1'] = value.employee_name
                formatLoop['forValue2'] = value.info
                formatLoop['forValue3'] =  formatDate('date', value.transaction_no)
                formatLoop['forState'] = 'Expiring'

                formatData.push(formatLoop)
              }

              expiringDocFull.value = formatData
              // console.log("cek expiring document", expiringDocFull.value)
            }

            // console.log("cek document expired prev", prevExdDocument)
            // Expired document
            if(prevExdDocument) {
              const formatData = []

              for (const [index, value] of Object.entries(prevExdDocument)) {
                // const formatLoop = {
                //   id: null,
                //   value1: value.employee_name,
                //   value2: value.info,
                //   value3: formatDate('date', value.transaction_no),
                //   state: null
                // }

                const formatLoop = value
                formatLoop['forId'] = null
                formatLoop['forFormatDate'] = value.transaction_no
                formatLoop['forValue1'] = value.employee_name
                formatLoop['forValue2'] = value.info
                formatLoop['forValue3'] =  formatDate('date', value.transaction_no)
                formatLoop['forState'] = 'Expired'

                formatData.push(formatLoop)
              }

              expiredDocFull.value = formatData
              // console.log("cek expired document", expiredDocFull.value)
            }
          }

          // ----- Data punishment this month -----
          if(response8.data.data) {
            const prevData = response8.data.data
            // console.log("cek punishment", prevData)

            if(prevData) {
              for (const [index, value] of Object.entries(prevData)) {
                if(value.id == 'consider_in_payroll') {
                  const formatData = []

                  if(value.list) {
                    for (const [list, child] of Object.entries(value.list)) {
                      const formatLoop = {
                        id: child.id,
                        value1: child.number,
                        value2: child.punishment_description,
                        value3: formatDate('date', child.transaction_date),
                        value4: child.employee_name,
                        value5: null,
                        state: null
                      }
                      formatData.push(formatLoop)
                    }
                  }

                  punishmentPayroll.value = formatData
                  // console.log("cek loop child payroll", punishmentPayroll.value)
                }
                else if(value.id == 'consider_in_performance') {
                  const formatData = []

                   if(value.list) {
                    for (const [list, child] of Object.entries(value.list)) {
                      const formatLoop = {
                        id: child.id,
                        value1: child.number,
                        value2: child.punishment_description,
                        value3: formatDate('date', child.transaction_date),
                        value4: child.employee_name,
                        value5: null,
                        state: null
                      }
                      formatData.push(formatLoop)
                    }
                  }

                  punishmentPerfomance.value = formatData
                  // console.log("cek loop child perfomance", punishmentPerfomance.value)
                }
                else if(value.id == 'relate_to_position') {
                  const formatData = []

                   if(value.list) {
                    for (const [list, child] of Object.entries(value.list)) {
                      const formatLoop = {
                        id: child.id,
                        value1: child.number,
                        value2: child.punishment_description,
                        value3: formatDate('date', child.transaction_date),
                        value4: child.employee_name,
                        value5: null,
                        state: null
                      }
                      formatData.push(formatLoop)
                    }
                  }

                  punishmentPosition.value = formatData
                  // console.log("cek loop child position", punishmentPosition.value)
                }
                else if(value.id == 'is_terminated') {
                  const formatData = []

                   if(value.list) {
                    for (const [list, child] of Object.entries(value.list)) {
                      const formatLoop = {
                        id: child.id,
                        value1: child.number,
                        value2: child.punishment_description,
                        value3: formatDate('date', child.transaction_date),
                        value4: child.employee_name,
                        value5: null,
                        state: null
                      }
                      formatData.push(formatLoop)
                    }
                  }

                  punishmentTerminated.value = formatData
                  // console.log("cek loop child terminated", punishmentTerminated.value)
                }
              }
            }
          }

          // ----- Data punishment all month & year -----
          if(response9.data.data) {
            const prevData = response9.data.data
            // console.log("cek punishment all", prevData)

            if(prevData) {
              for (const [index, value] of Object.entries(prevData)) {
                if(value.id == 'consider_in_payroll') {
                  const formatData = []

                  if(value.list) {
                    for (const [list, child] of Object.entries(value.list)) {
                      const formatLoop = child
                      formatLoop['forId'] = child.id
                      formatLoop['forFormatDate'] = child.transaction_date
                      formatLoop['forValue1'] = child.number
                      formatLoop['forValue2'] = `<table style="width: 100%;"><tr><td style="width: 100px; font-weight: 500;">Punishment</td><td style="width: 10px;">:</td><td style="width: calc(100% - 110px);">${ child.punishment_description }</td></tr><tr><td style="width: 100px; font-weight: 500;">Violation</td><td style="width: 10px;">:</td><td style="width: calc(100% - 110px);">${ child.violation_description }</td></tr></table>`
                      formatLoop['forValue3'] = formatDate('date', child.transaction_date)
                      formatLoop['forValue4'] = child.employee_name,
                      formatLoop['forState'] = 'yellow'
                      formatData.push(formatLoop)
                    }
                  }

                  punishmentPayrollFull.value = formatData
                  // console.log("cek loop child payroll full", punishmentPayrollFull.value)
                }
                else if(value.id == 'consider_in_performance') {
                  const formatData = []

                   if(value.list) {
                    for (const [list, child] of Object.entries(value.list)) {
                      const formatLoop = child
                      formatLoop['forId'] = child.id
                      formatLoop['forFormatDate'] = child.transaction_date
                      formatLoop['forValue1'] = child.number
                      formatLoop['forValue2'] = `<table style="width: 100%;"><tr><td style="width: 100px; font-weight: 500;">Punishment</td><td style="width: 10px;">:</td><td style="width: calc(100% - 110px);">${ child.punishment_description }</td></tr><tr><td style="width: 100px; font-weight: 500;">Violation</td><td style="width: 10px;">:</td><td style="width: calc(100% - 110px);">${ child.violation_description }</td></tr></table>`
                      formatLoop['forValue3'] = formatDate('date', child.transaction_date)
                      formatLoop['forValue4'] = child.employee_name,
                      formatLoop['forState'] = 'green'
                      formatData.push(formatLoop)
                    }
                  }

                  punishmentPerfomanceFull.value = formatData
                  // console.log("cek loop child perfomance full", punishmentPerfomanceFull.value)
                }
                else if(value.id == 'relate_to_position') {
                  const formatData = []

                   if(value.list) {
                    for (const [list, child] of Object.entries(value.list)) {
                      const formatLoop = child
                      formatLoop['forId'] = child.id
                      formatLoop['forFormatDate'] = child.transaction_date
                      formatLoop['forValue1'] = child.number
                      formatLoop['forValue2'] = `<table style="width: 100%;"><tr><td style="width: 100px; font-weight: 500;">Punishment</td><td style="width: 10px;">:</td><td style="width: calc(100% - 110px);">${ child.punishment_description }</td></tr><tr><td style="width: 100px; font-weight: 500;">Violation</td><td style="width: 10px;">:</td><td style="width: calc(100% - 110px);">${ child.violation_description }</td></tr></table>`
                      formatLoop['forValue3'] = formatDate('date', child.transaction_date)
                      formatLoop['forValue4'] = child.employee_name,
                      formatLoop['forState'] = 'yellow'
                      formatData.push(formatLoop)
                    }
                  }

                  punishmentPositionFull.value = formatData
                  // console.log("cek loop child position full", punishmentPositionFull.value)
                }
                else if(value.id == 'is_terminated') {
                  const formatData = []

                   if(value.list) {
                    for (const [list, child] of Object.entries(value.list)) {
                      const formatLoop = child
                      formatLoop['forId'] = child.id
                      formatLoop['forFormatDate'] = child.transaction_date
                      formatLoop['forValue1'] = child.number
                      formatLoop['forValue2'] = `<table style="width: 100%;"><tr><td style="width: 100px; font-weight: 500;">Punishment</td><td style="width: 10px;">:</td><td style="width: calc(100% - 110px);">${ child.punishment_description }</td></tr><tr><td style="width: 100px; font-weight: 500;">Violation</td><td style="width: 10px;">:</td><td style="width: calc(100% - 110px);">${ child.violation_description }</td></tr></table>`
                      formatLoop['forValue3'] = formatDate('date', child.transaction_date)
                      formatLoop['forValue4'] = child.employee_name,
                      formatLoop['forState'] = 'red'
                      formatData.push(formatLoop)
                    }
                  }

                  punishmentTerminatedFull.value = formatData
                  // console.log("cek loop child terminated full", punishmentTerminatedFull.value)
                }
              }
            }

            isLoading.value = false
          }
        }
        catch(error) {
          console.log(error)
        }
      }

      const getDataSec = async (profile, loop) => {
        const thisDate = new Date()
        let thisYear = thisDate.getFullYear()
        let thisMonth = thisDate.getMonth() + 1
        let thisDay = thisDate.getDate()
        let thisHours = thisDate.getHours()
        let thisMinutes = thisDate.getMinutes()
        let thisSeconds = thisDate.getSeconds()
        thisMonth = thisMonth <= 9 ? `${thisMonth}`.padStart(2, 0) : thisMonth
        thisDay = thisDay <= 9 ? `${thisDay}`.padStart(2, 0) : thisDay
        thisHours = thisHours <= 9 ? `${thisHours}`.padStart(2, 0) : thisHours
        thisMinutes = thisMinutes <= 9 ? `${thisMinutes}`.padStart(2, 0) : thisMinutes
        thisSeconds = thisSeconds <= 9 ? `${thisSeconds}`.padStart(2, 0) : thisSeconds
        const dateNow = thisYear + '-' + thisMonth + '-' + thisDay + ' ' + thisHours + ':'+ thisMinutes + ':' + thisSeconds

        const headers = {'Content-Encoding': 'gzip'}
        const profileImg = {id: employeeId.value}
        const attendance = {
          id: profile.id,
          shift_id: null,
          work_unit_id: profile.work_unit_id,
          month: !loop ? thisMonth : ('0' + ((thisDate.getMonth() + 1) - loop)).slice(-2),
          year: thisYear
        }

        try {
          const [response1] = await Promise.all([
            axios.get("presenceemployee", { headers, params: attendance }),
            // axios.get("get-photo-employee", { headers, params: profileImg })
          ])

          if(response1.data.data) {
            if(!loop) {
              thisMonthNow.value = formatDate('monthYear', dateNow)
              attendanceDay.value = formatDate('dateTime', dateNow)
              attendanceNow.value = response1.data.data[0][thisDay]
              attendanceData.value = response1.data.data[0]

              // console.log("cek kehadiran 1", response1.data.data)

              const revPre = {
                year: thisYear,
                month_number: Number(attendance.month),
                month_name: formatDate('month', dateNow),
                month_presence: response1.data.data[0]
              }

              attendanceALL.value.push(revPre)

              for (let i = 0; i < (thisDate.getMonth()); i++) {
                getDataSec(profile, (i + 1))
              }
            } else {
              const revPre = {
                year: thisYear,
                month_number: Number(attendance.month),
                month_name: monthsEn[Number(attendance.month) - 1],
                month_presence: response1.data.data[0]
              }

              attendanceALL.value.push(revPre)
            }

            // console.log("cek kehadiran", attendanceALL.value)
          }

          // console.log("cek attendance ges", attendanceALL.value)

          // if(response2.data.data) {
          //   console.log("cek employee image profile", response2.data.data)
          //   isLoading.value = false
          // }
        }
        catch(error) {
          console.log(error)
        }
      }


      const trainingBackData = ref([])
      const remainingAllData = ref([])
      const employeeBackData = ref([])
      const punishmentBackData = ref([])
      const refreshData = async () => {
        const headers = {'Content-Encoding': 'gzip'}
        const paramsTraining = {user_id: localStorage.getItem("user_id")}
        const paramsEmployee = {
          user_id: localStorage.getItem('user_id'),
          branch_id: localStorage.getItem('branch_id'),
        }

        try {
          const [response1, response2, response3, response4] = await Promise.all([
            axios.get("employee-training", { headers, params: paramsTraining }),
            axios.get("hrleave-employee", { headers }),
            axios.get("employee", { headers, params: paramsEmployee }),
            axios.get("punishment-transaction", { headers }),
          ])

          if(response1.data.data) {
            trainingBackData.value = response1.data.data
            // console.log("cek back training", trainingBackData.value)
          }

          if(response2.data.data) {
            remainingAllData.value = response2.data.data
            // console.log("cek back leave", remainingAllData.value)
          }

          if(response3.data.data) {
            employeeBackData.value = response3.data.data
            // console.log("cek back employee", employeeBackData.value)
          }

          if(response4.data.data) {
            punishmentBackData.value = response4.data.data
            // console.log("cek back employee", punishmentBackData.value)
            isLoading.value = false
          }
        }
        catch(error) {
          console.log(error)
        }
      }


      const detailModal = ref(false)
      const modalType = ref(null)
      const detailData = ref({})
      const openDetail = (data, type) => {
        // console.log("cek base modal", data, type)
        if(data) {
          const prevData = data.data ? data.data : data ? data : {}
          const prevType = data.type ? data.type : type ? type : null

          modalType.value = (prevType ? prevType : null)
          // detailModal.value = true

          // console.log("cek type modal", prevType, prevData)

          if((prevType == 'training') && prevData && trainingBackData.value) {
            detailData.value = trainingBackData.value.filter(item => item.id == prevData.id)[0]
            detailModal.value = true
          }
          else if((prevType == 'leave') && prevData && remainingAllData.value) {
            detailData.value = remainingAllData.value.filter(item => item.id == prevData.id)[0]
            detailModal.value = true
          }
          else if(['decree', 'document', 'contract'].includes(prevType) && prevData && employeeBackData.value) {
            detailData.value = employeeBackData.value.filter(item => item.employee_id == (prevData.employee_id ? prevData.employee_id : prevData.id))[0]
            detailModal.value = true
          }
          else if((prevType == 'punishment') && prevData && punishmentBackData.value) {
            detailData.value = punishmentBackData.value.filter(item => item.id == prevData.id)[0]
            detailModal.value = true
          }
          else {
            detailModal.value = false
            modalType.value = null
            detailData.value = {}
          }

          // console.log("cek prev data detail", detailData.value)
        }else {
          detailModal.value = false
          modalType.value = null
          detailData.value = {}
        }

        // if(data) {
        //   modalType.value = (data.type ? data.type : null)
        //   detailModal.value = true
        // } else {
        //   modalType.value = null
        //   detailModal.value = false
        // }

        // if(data) {
        //   if((data.type == 'training') && data.data && trainingBackData.value) {
        //     detailData.value = trainingBackData.value.filter(item => item.id == data.data.id)[0]
        //   }
        //   else if((data.type == 'leave') && data.data && remainingAllData.value) {
        //     detailData.value = remainingAllData.value.filter(item => item.id == data.data.id)[0]
        //   }
        // }else {
        //   detailData.value = {}
        // }
      }


      onBeforeMount(() => {
        getData()
        refreshData()
      })


      onMounted(() => {

      })

      watchEffect(() => {

      })


      return {
        mdiClose,
        tabsList,
        tabActive,
        openTab,
        roles,
        isLoading,
        formatDate,
        profileData,
        attendanceDay,
        thisMonthNow,
        modalDetail,
        objectDetail,
        openModal,
        attendanceNow,
        attendanceData,
        attendanceALL,
        leaveBalance,
        latestUpdate,
        latestUpdateFull,
        leaveWaiting,
        leaveApprove,
        leaveReject,
        leaveWaitingFull,
        leaveApproveFull,
        leaveRejectFull,
        trainingWaiting,
        trainingApprove,
        trainingReject,
        trainingWaitingFull,
        trainingApproveFull,
        trainingRejectFull,
        expiringDoc,
        expiredDoc,
        expiringLeave,
        expiredLeave,
        expiringContract,
        expiredContract,
        expiringDocFull,
        expiredDocFull,
        expiringLeaveFull,
        expiredLeaveFull,
        expiringContractFull,
        expiredContractFull,
        expiringCareer,
        expiredCareer,
        expiringCareerFull,
        expiredCareerFull,
        remainingAllData,
        employeeBackData,
        punishmentPayroll,
        punishmentPayrollFull,
        punishmentPerfomance,
        punishmentPerfomanceFull,
        punishmentPosition,
        punishmentPositionFull,
        punishmentTerminated,
        punishmentTerminatedFull,
        detailModal,
        modalType,
        detailData,
        openDetail,
        refreshData
      }
    }
  }
</script>
